import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderTextareaComponent } from './dynamic-page-builder-textarea.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderTextareaFormComponent } from './textarea-form/page-builder-textarea-form.component';

@NgModule({
    declarations: [
        PageBuilderTextareaFormComponent, DynamicPageBuilderTextareaComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderTextareaComponent
    ]
})
export class PageBuilderTextareaModule {}